module.exports = __webpack_public_path__ + "static/media/kai.724564ee.m4a";